import { Link } from 'react-router-dom';

const signs = [
  'руководитель проверяет каждую мелочь;',
  'сотрудники боятся принимать решения;',
  'все вопросы идут наверх;',
  'руководитель перегружен операционной работой;',
  'сотрудники привыкают ждать указаний;',
  'инициатива снижается, команда работает формально.',
];

export default function ControlVsManagement() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Микроменеджмент: когда руководитель сам становится ограничением команды
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему контроль не равен управлению и как переход к контролю результата меняет команду
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-base font-bold text-gray-900 mb-4">Признаки микроменеджмента</h3>
            <div className="space-y-2.5">
              {signs.map((s, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <i className="ri-alert-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-50 rounded-2xl border border-teal-200 p-6 md:p-8 flex flex-col justify-center">
            <p className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-2">Переход</p>
            <p className="text-2xl md:text-3xl font-bold text-teal-900 leading-tight mb-4">
              Контроль результата вместо контроля каждого действия
            </p>
            <p className="text-teal-800 text-sm leading-relaxed">
              Руководитель определяет ожидаемый результат, критерии качества и контрольные точки, а сотрудник сам выбирает способ выполнения в рамках полномочий. Это повышает самостоятельность и снижает нагрузку на руководителя.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach"
            className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-800 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            Делегирование и постановка задач
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory"
            className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-800 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            Обратная связь и сложные разговоры
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}